const Banner = () => {
  return (
    <div className="w-fit relative">
      <img
        alt="banner"
        src={"https://cdn.firouzeh.com/public/pattern-pre-login.svg"}
        className="w-screen md:w-auto "
      />
    </div>
  );
};
export default Banner;
